// extracted by mini-css-extract-plugin
export default {"noteWrap":"NoteForLandlord_noteWrap__PKDk6","note":"NoteForLandlord_note__b9vd2","empty":"NoteForLandlord_empty__8QAic"};